module.exports = __webpack_public_path__ + "assets/img/tec_icon2@2x.a1382397.png";